export default {
  setContainer(state, data) {
    state.container = data;
  },
};
